module.exports = __webpack_public_path__ + "img/slide2.8406c630.png";